import { Stack, Typography, Box } from "@mui/material";
import CRSearchDatasetViewer from "src/views/datasets/components/CRSearchDatasetViewer";

type CRSearchListProps = {
  crSearchResults: any[];
  result?: any[];
};

const CRSearchList = ({ crSearchResults, result }: CRSearchListProps) => {
  if (!crSearchResults || crSearchResults.length === 0) {
    return (
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ padding: 4, textAlign: "center" }}
      >
        <Typography variant="body2" color="text.secondary">
          No CR search results available
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
          Use the Smart Search tool to generate citation/reference sources
        </Typography>
      </Stack>
    );
  }

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Conditional Rendering Based on View Mode */}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <CRSearchDatasetViewer toolResult={result} />
      </Box>
    </Box>
  );
};

export default CRSearchList;
